import {VehicleEmissionTestModel} from './vehicle-emission-test.model';

export class VehicleEmissionCheckStatusRegistrationModel {
    public id: number;
    public vehicleEmissionCheckStatusTypeID: number;
    public registrationID: number;
    public vehicleEmissionsTestID: number;
    public vehicleEmissionTest: VehicleEmissionTestModel;
    public renewalFleetVehicle: boolean;
}
